<template>
  <div>
    <el-row :gutter="20" style="margin-left: 5px;" type="flex">
      <el-col :span="8"><el-input placeholder="Search by Name / Employee ID / Phone" prefix-icon="el-icon-search"
          v-model="filters.searchString">
        </el-input>
      </el-col>
      <el-col :span="3.5">
        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="dialogs.newUser = true">New
          User</el-button>
      </el-col>
      <el-col :span="3.5" :offset="6">
        <p class="mt-2">{{ itemsShowing }}</p>
      </el-col>
    </el-row>
    <el-table ref="elTable" :data="filteredData" :row-key="getRowKey" style="width: 99%; margin-left: 5px;" border
      size="small" :header-cell-style="{ background: '#f1f1f5', color: 'black', textAlign: 'center' }">
      <el-table-column label="Sl.No" type="index" align="center" width="75" />
      <el-table-column label="Employee ID" property="employee_id" align="center" sortable />
      <el-table-column label="First Name" property="firstName" align="center" sortable />
      <el-table-column label="Last Name" property="lastName" align="center" />
      <el-table-column label="Phone" property="phone" align="center" />
      <el-table-column label="Email" property="email" align="center" />
      <el-table-column label="Role" property="role_name" align="center" :filters="filters.roles"
        :filter-method="filterHandler" />
      <el-table-column label="Actions" width="180" align="center">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="Edit User Details" placement="bottom">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle
              @click="onEditClick(scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Change Notification Interval" placement="bottom"
            v-show="scope.row.role == 2">
            <el-button size="mini" type="warning" icon="el-icon-date" circle
              @click="(dialogs.notificationInterval = true), (selected.user = scope.row)"></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Block" placement="bottom">
            <el-button size="mini" type="danger" icon="el-icon-circle-close" circle v-if="scope.row.activeStatus"
              @click="blockUser(scope.row)" />
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="Unblock" placement="bottom">
            <el-button size="mini" type="success" icon="el-icon-circle-check" circle v-if="!scope.row.activeStatus"
              @click="unBlockUser(scope.row)" />
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- #region Notification Interval Dialog -->
    <el-dialog title="Change Notification Interval" :visible.sync="dialogs.notificationInterval">
      <el-input-number v-model="selected.user.notification_interval" :min="1"></el-input-number>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.notificationInterval = false">Cancel</el-button>
        <el-button type="primary" @click="updateNotificationInterval()">Confirm</el-button>
      </span>
    </el-dialog>
    <!-- #endregion -->

    <!-- #region New User dialog -->
    <el-dialog :title="isEdit ? 'Edit User Details' : 'Create New User'" :visible.sync="dialogs.newUser" width="70%">
      <el-form :model="form" label-position="top" ref="ruleForm">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="First Name" prop="firstName" required
              :rules="[{ required: true, message: 'First Name is required' }]">
              <el-input v-model="form.firstName" placeholder="First Name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Last Name" prop="lastName" required
              :rules="[{ required: true, message: 'Last Name is required' }]">
              <el-input v-model="form.lastName" placeholder="Last Name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Employee ID" prop="employee_id"
              :rules="[{ required: true, message: 'Employee ID is required' }]">
              <el-input v-model="form.employee_id" placeholder="Employee ID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Phone" prop="phone" :rules="[{ required: true, message: 'Phone is required' }]">
              <el-input v-model="form.phone" placeholder="Phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Email" prop="email" :rules="[{ required: true, message: 'Email is required' }]">
              <el-input v-model="form.email" placeholder="Email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Address" prop="Address">
              <el-input v-model="form.address" placeholder="Address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="Role" prop="role" :rules="[{ required: true, message: 'Role is required' }]">
              <el-select v-model.number="form.role" clearable placeholder="Select Role">
                <el-option v-for="item in roles" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="State" prop="state" :rules="[{ required: true, message: 'State is required' }]">
              <el-select v-model.number="form.state" clearable placeholder="Select Sate">
                <el-option v-for="item in states" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Password" prop="password" v-if="!isEdit">
              <el-input v-model="form.password" placeholder="Password"></el-input>
              <div class="password-note" style="font-size: 12px; color: #909399; line-height: 1.4; margin-top: 4px;">
                <i class="el-icon-info"></i> Please save this password securely
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogs.newUser = false">Cancel</el-button>
        <el-button type="primary" @click="isEdit ? onUserUpdate() : onSave()">Save</el-button>
      </span>
    </el-dialog>
    <!-- #endregion -->
  </div>
</template>

<script>
import Axios from "axios";
import { AlertService } from "../utils/AlertService";

export default {
  name: "Users",
  watch: {
    "dialogs.newUser"(val) {
      if (!val) {
        this.form = Object.assign({}, this.default);
        this.isEdit = false;
      }
      if (!this.isEdit) {
        // Generate a fresh random password only when opening the dialog for a new user
        this.form.password = this.generateRandomPassword();
      }
    },
  },
  computed: {
    filteredData() {
      let searchString = this.filters.searchString;
      return this.users.items.filter(function (item) {
        return (
          item.firstName.toUpperCase().indexOf(searchString.toUpperCase()) >= 0 ||
          item.employee_id.toUpperCase().indexOf(searchString.toUpperCase()) >= 0 ||
          item.phone.toUpperCase().indexOf(searchString.toUpperCase()) >= 0
        );
      });
    },
    itemsShowing() {
      if (!this.isMounted) return;
      const filteredItemsLength = this.$refs.elTable.tableData.length;
      const totalItemsLength = this.users.items.length;
      return `Showing ${filteredItemsLength} / ${totalItemsLength} Items`;
    },
  },
  data() {
    return {
      users: {
        items: [],
        selectedId: null,
      },
      states: [],
      roles: [],
      form: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        address: "",
        photo: "",
        region: 0,
        state: "",
        role: "",
        password: "",
        employee_id: "",
        notification_interval: null,
      },
      default: {
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        address: "",
        photo: "",
        region: 0,
        state: "",
        role: "",
        password: "",
        employee_id: "",
        notification_interval: null,
      },
      selected: {
        user: {
          notification_interval: null,
        },
      },
      dialogs: {
        newUser: false,
        notificationInterval: false,
      },
      filters: {
        roles: [],
        searchString: "",
      },
      isMounted: false,
      isEdit: false,
    };
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    filterHandler(value, row, column) {
      return this.resolve(column["property"], row) === value;
    },
    resolve(path, obj) {
      return path.split(".").reduce(function (prev, curr) {
        return prev ? prev[curr] : null;
      }, obj || self);
    },
    async onInit() {
      await this.getStates();
      await this.getRoles();
      await this.getAllUsers();
    },
    async getAllUsers() {
      Axios.get("user")
        .then((res) => {
          this.users.items = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getStates() {
      Axios.get("states")
        .then((res) => {
          this.states = [...new Set(res.data.map((item) => ({ value: item.id, label: item.label })))].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getRoles() {
      Axios.get("roles")
        .then((res) => {
          this.roles = [...new Set(res.data.map((item) => ({ value: item.id, label: item.role_name })))].sort((a, b) =>
            a.label.localeCompare(b.label)
          );
          this.filters.roles = [...new Set(res.data.map((item) => item.role_name))].map((item) => ({ text: item, value: item }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async updateNotificationInterval() {
      Axios.patch(`user/updateNotificationInterval/${this.selected.user.user_id}/${this.selected.user.notification_interval}`)
        .then((res) => {
          this.dialogs.notificationInterval = false;
          AlertService.success(`Interval updated successfully`);
          console.log(res.data);
        })
        .catch((err) => {
          console.log(err);
          AlertService.error(err.response.data.message);
        });
    },
    async blockUser(row) {
      Axios.patch(`user/block/${row.user_id}`)
        .then((res) => {
          AlertService.success(`User blocked successfully`);
          console.log(res.data);
          this.onInit();
        })
        .catch((err) => {
          console.log(err);
          AlertService.error(err.response.data.message);
        });
    },
    async unBlockUser(row) {
      Axios.patch(`user/un-block/${row.user_id}`)
        .then((res) => {
          AlertService.success(`User unblocked successfully`);
          console.log(res.data);
          this.onInit();
        })
        .catch((err) => {
          console.log(err);
          AlertService.error(err.response.data.message);
        });
    },
    onEditClick(row) {
      this.isEdit = true;
      this.form = Object.assign({}, row);
      this.dialogs.newUser = true;
    },
    async onSave() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (!valid) return false;

        await Axios.post("user", this.form)
          .then((res) => {
            console.log(res.data);
            this.dialogs.newUser = false;
            AlertService.success(`User added successfully.`);
            this.onInit();
          })
          .catch((err) => {
            console.log(err);
            AlertService.error(err.response.data.message);
          });
      });
    },
    async onUserUpdate() {
      Axios.patch(`user/${this.form.user_id}`, this.form)
        .then((res) => {
          console.log(res.data);
          AlertService.success(`User details has been updated successfully.`);
          this.dialogs.newUser = false;
          this.onInit();
        })
        .catch((err) => {
          console.log(err);
          AlertService.error(err.response.data.message);
        });
    },
    generateRandomPassword(length = 8) {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*";
      let password = "";
      for (let i = 0; i < length; i++) {
        password += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return password;
    }
  },
  async mounted() {
    await this.onInit();
    this.isMounted = true;
  },
};
</script>
<style></style>
